// (C) Copyright 2020 CNCC Services <https://www.cncc.fr/>
// This program is the sole property of CNCC Services and is not free software.

import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App, { Application } from "./App";
import { authentifiedUserEvent } from "./state/auth/AuthEvents";

if (process.env.REACT_APP_TEST_MODE === "1") {
  authentifiedUserEvent({
    id: "test",
    sub: "test",
    firstName: "Firstname",
    lastName: "Lastname",
    email: "test@reeliant.com",
    rights: {}
  });
}

ReactDOM.render(
  <React.StrictMode>
    {process.env.REACT_APP_TEST_MODE === "1" ? <Application /> : <App />}
  </React.StrictMode>,
  document.getElementById("root")
);
